module.exports = __webpack_public_path__ + "static/media/abc-trek.ba6a1003.jpg";